import DateTime from './DateTime.js';
import _ from 'lodash';

const units = ['hour', 'minute'];

export default class Time {
  static get now() {
    return new Time(DateTime.now);
  }

  constructor(value) {
    if (_.isNumber(value)) {
      this.minutes = value;
    } else if (_.isString(value)) {
      const parseIntSafe = str => (_.isEmpty(str) ? 0 : parseInt(str, 10));
      const [hour, minute] = value.split(':').map(parseIntSafe);
      this.minutes = hour * 60 + minute;
    } else if (value instanceof DateTime || value instanceof Time) {
      this.minutes = value.hour * 60 + value.minute;
    } else {
      this.minutes = 0;
    }
  }

  get hour() {
    return Math.floor(this.minutes / 60);
  }

  get minute() {
    return this.minutes % 60;
  }

  valueOf() {
    return this.minutes;
  }

  toJSON() {
    return this.minutes;
  }

  toString() {
    // noinspection JSCheckFunctionSignatures
    return `${_.padStart(this.hour, 2, '0')}:${_.padStart(this.minute, 2, '0')}`;
  }

  set(value) {
    return new Time(DateTime.now.set(value));
  }

  add(number, unit) {
    if (!units.includes(unit)) {
      throw new Error('Invalid unit ' + unit);
    }
    return new Time(DateTime.now.set({ hour: this.hour, minute: this.minute }).add(number, unit));
  }

  subtract(number, unit) {
    if (!units.includes(unit)) {
      throw new Error('Invalid unit ' + unit);
    }
    return new Time(
      DateTime.now.set({ hour: this.hour, minute: this.minute }).subtract(number, unit)
    );
  }

  isEqual(dt) {
    return this.hour === dt.hour && this.minute === dt.minute;
  }

  isBefore(dt) {
    if (this.hour < dt.hour) return true;
    return this.hour === dt.hour && this.minute < dt.minute;
  }

  isAfter(dt) {
    if (this.hour > dt.hour) return true;
    return this.hour === dt.hour && this.minute > dt.minute;
  }

  format(formatStr, locale) {
    return DateTime.now.set({ hour: this.hour, minute: this.minute }).format(formatStr, locale);
  }
}
